import React, { useEffect } from "react";
import "./Services.css";
import AOS from "aos";
import "aos/dist/aos.css";

const data = [
  {
    img: "/edu.webp",
    title: "Education",
    desc: `In the future, we aim to provide advanced learning opportunities for children through digital classrooms, scholarship programs, and personalized mentorship. Our goal is to ensure that every child—regardless of background—gets the education needed to secure a bright and confident future.`,
  },
  {
    img: "/health.webp",
    title: "Health",
    desc: `We plan to expand our healthcare initiatives by organizing regular medical camps, offering early diagnosis support, and helping families access essential treatment. Our vision is to build healthier communities through preventive care and timely medical assistance.`,
  },
  {
    img: "/hospital1.png",
    title: "OurCountry OurPeople HealthCare Center",
    desc: `In the coming years, develop professional, technical, and medical institutions in compliance with statutory and regulatory bodies. Establish and support hospitals, health centers, orphanages, homes for the aged, and welfare shelters.`,
  },
];

const Services = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <div className="what-container">
      <h2 className="main-title" data-aos="fade-up">What we do</h2>
      <div className="main-underline" data-aos="fade-left"></div>

      <p className="top-text" data-aos="fade-up" data-aos-delay="100">
        In the coming years, our organization aims to expand our work across
        education, healthcare, and women empowerment. We are committed to building
        long-term programs that provide continuous learning opportunities, early
        medical support, and sustainable growth for women across Tamil Nadu.
      </p>

      <p className="top-text" data-aos="fade-up" data-aos-delay="200">
        Our future projects will focus on creating accessible learning centers,
        setting up health camps in rural areas, and launching skill-development
        initiatives that help people become financially independent. With the
        support of volunteers, partners, and caring communities, we are working
        towards a stronger, healthier, and more empowered society for the next
        generation.
      </p>

      <div className="card-container">
        {data.map((item, i) => (
          <div className="card" key={i} data-aos="fade-up" data-aos-delay={i * 150}>
            <div className="card-img-container">
              <img src={item.img} className="card-img" alt={item.title} />
            </div>
            <div className="card-body">
              <h3 className="card-title">{item.title}</h3>
              <p className="card-desc">{item.desc}</p>
              <a href="/ourprojects" className="read-more">
                Read More →
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
